import { API_BASE_URL } from "constants/env";
import axios from "axios";

export const baseHttp = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    // "Content-Type": "application/json",
    "x-client": "perks-n-rewards-company",
  },
});
